export default "__VITE_ASSET__C8BV3Pdv__"